export const FETCH_ADMIN_ACTIVE_LOGS = "FETCH_ADMIN_ACTIVE_LOGS";
export const FETCH_ADMIN_ACTIVE_LOGS_SUCCESS =
  "FETCH_ADMIN_ACTIVE_LOGS_SUCCESS";
export const FETCH_ADMIN_ACTIVE_LOGS_ERROR = "FETCH_ADMIN_ACTIVE_LOGS_ERROR";

export const CLEAR_ADMIN_ACTIVITY_LOG = "CLEAR_ADMIN_ACTIVITY_LOG";
